import {
    withHeaders,
    instance as axiosInstance,
} from '../core/util/axiosInstance';
import { getDefaultHeaders, useAlert } from '../core';
import { MutationFunction, UseMutationResult, useMutation } from 'react-query';
import { AxiosResponse } from 'axios';
import { commonShowAlert } from '../lib';
import { FILE_UPLOAD_SUCCESS_MSG } from '../pages/job-manager/job-manager-helper';

interface PostResetSDZDataJobProps {
    token: string;
    email?: string;
}

export const postResetSDZDataJob: MutationFunction<
    AxiosResponse<any>,
    PostResetSDZDataJobProps
> = async (props: PostResetSDZDataJobProps) => {
    const { token, email } = props;
    const headers = getDefaultHeaders(token);
    const resetSDZDataJobUrl = '/jobs/sdz/reset';

    return axiosInstance().post(
        resetSDZDataJobUrl,
        {
            emailResultsTo: email ?? '',
        },
        withHeaders(headers)
    );
};

export const useResetSDZDataJob = (): UseMutationResult<
    AxiosResponse<any>,
    unknown,
    PostResetSDZDataJobProps
> => {
    const { showAlert, hideAlert, showErrorDetails } = useAlert();

    return useMutation(postResetSDZDataJob, {
        onSuccess: () => {
            commonShowAlert(
                showAlert,
                hideAlert,
                'success',
                FILE_UPLOAD_SUCCESS_MSG
            );
        },
        onError: (error: any) => {
            const errorMessage: string =
                error?.data?.message ?? 'Unable to reset sdz data';
            commonShowAlert(
                showAlert,
                hideAlert,
                'error',
                errorMessage,
                JSON.stringify(error?.data ?? ''),
                showErrorDetails
            );
        },
    });
};
